//REPORTED USER ACTIONS
export const GET_REPORTED_USERSUCCESS = "GET_REPORTED_USERSUCCESS";
export const GET_REPORTED_USERERROR = "GET_REPORTED_USERERROR";
//REPORTED USER LIMIT CHANGE
export const REPORTED_USER_LIMIT_CHANGE = "REPORTED_USER_LIMIT_CHANGE"
//REPORTED USER PAGE CHANGE
export const REPORTED_USER_PAGE_CHANGE = "REPORTED_USER_PAGE_CHANGE"